import { get, writable } from "svelte/store";
import AlertsStore from "../Alerts/Store";
import API from "../API/API";
import LoadState from "../Enums/LoadState";
import GeoHelper from "../Helpers/GeoHelper";
import IconMode from "../Map/Enums/IconMode";
import MapDataSource from "../Map/Enums/MapDataSource";
import MapLayer from "../Map/Enums/MapLayer";
import MapLayerGroup from "../Map/Enums/MapLayerGroup";
import MapLayerManager from "../Map/MapLayerManager";
import { Layout, Paint } from "../Map/MapLayerStyles";
import MapStore from "../Map/Store";
import Aircraft from "../Models/Aircraft";
import AircraftProperty from "../Models/Enums/AircraftProperty";
import AircraftSpireDataPropertyMap from "../Models/Enums/AircraftSpireDataPropertyMap";
import VesselGroup from "../Models/VesselGroup";

const AviationAlertsStore = {
	meta: {
		mapInitted: writable(false),
		lastUpdated: writable(new Date(0)),
		loadState: writable(LoadState.INIT)
	},
	results: {
		aircraft: writable([]),
		aircraftGroup: new VesselGroup()
	},
	filters: {
		eas: AlertsStore.generators.filterType()
	},
	iconMode: writable(IconMode.AVIATION_ALERT),
	actions: {
		initData: () => {
			AviationAlertsStore.meta.loadState.set(LoadState.LOADING);

			API.get("datasets/aviation-alerts-eas").then((response) => {
				const data = JSON.parse(response.dataset.content);
				const aircraftGroup = AviationAlertsStore.results.aircraftGroup;

				const results = [];
				for (let i = 0; i < data.features.length; i++) {
					const a = new Aircraft(data.features[i], aircraftGroup, AircraftSpireDataPropertyMap);
					a.uniqidType = AircraftProperty.ICAO_ADDRESS;
					a.addAlertData("EAS");
					results.push(a);
				}

				AviationAlertsStore.results.aircraft.set(results);
				AviationAlertsStore.results.aircraftGroup.vessels.set(results);

				AviationAlertsStore.meta.loadState.set(LoadState.LOADED);
				AviationAlertsStore.meta.lastUpdated.set(Date.now());
				AviationAlertsStore.actions.updateMapSources();
			});// TODO no catch block?
		},
		initMap: (map) => {
			if (get(AviationAlertsStore.meta.mapInitted)) {
				return;
			}
			map.addSource(MapDataSource.AIRCRAFT_ALERTS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.AIRCRAFT_ALERTS_LINES, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.AIRCRAFT_ALERTS_POINTS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});

			map.addLayer({
				id: MapLayer.AIRCRAFT_ALERTS,
				type: "symbol",
				source: MapDataSource.AIRCRAFT_ALERTS,
				layout: Layout.selectableAircraft
			});
			map.addLayer(
				{
					id: MapLayer.AIRCRAFT_ALERTS_LINES,
					type: "line",
					source: MapDataSource.AIRCRAFT_ALERTS_LINES,
					paint: Paint.vesselTrails
				}
			);
			map.addLayer(
				{
					id: MapLayer.AIRCRAFT_ALERTS_POINTS,
					type: "symbol",
					source: MapDataSource.AIRCRAFT_ALERTS_POINTS,
					layout: Layout.historic
				}
			);
			map.setLayerZoomRange(MapLayer.AIRCRAFT_ALERTS_LINES, 0, 24);
			map.setLayerZoomRange(MapLayer.AIRCRAFT_ALERTS_POINTS, 0, 24);

			map.on("click", MapLayer.AIRCRAFT_ALERTS, (event) => {
				event.preventDefault();
				AviationAlertsStore.results.aircraftGroup.selectSingle(map, event, [MapLayer.AIRCRAFT_ALERTS], [AircraftProperty.ICAO_ADDRESS]);
			});

			MapLayerManager.addLayerGroup(MapLayerGroup.AIRCRAFT_ALERTS, [
				MapLayer.AIRCRAFT_ALERTS,
				MapLayer.AIRCRAFT_ALERTS_LINES,
				MapLayer.AIRCRAFT_ALERTS_POINTS
			], [
				MapDataSource.AIRCRAFT_ALERTS,
				MapDataSource.AIRCRAFT_ALERTS_LINES,
				MapDataSource.AIRCRAFT_ALERTS_POINTS
			]);

			AviationAlertsStore.meta.mapInitted.set(true);
			AviationAlertsStore.meta.lastUpdated.set(new Date(0));
		},
		deinitMap: () => {
			MapLayerManager.removeLayerGroup(MapLayerGroup.AIRCRAFT_ALERTS);
			AviationAlertsStore.meta.mapInitted.set(false);
		},
		updateMapSources: () => {
			if (!get(AviationAlertsStore.meta.mapInitted)) {
				console.log("🔄 Refreshing sources REJECTED (no map layers)");
				return;
			}
			console.log("🔄 Refreshing aviation sources...");
			const map = get(MapStore.mapbox.instance);

			const date = get(AviationAlertsStore.results.aircraftGroup.timeSliderData.value);
			const aircraftToDisplay = [];
			const aircrafts = get(AviationAlertsStore.results.aircraft);

			const easAlertData = AviationAlertsStore.filters.eas;
			const easAlertVisible = get(easAlertData.visible);

			aircrafts.forEach((aircraft) => {
				if (easAlertVisible) { // filthyhacks
					aircraft.updateSnapshot(date);
					aircraftToDisplay.push(aircraft.currentFeature);
				}
			});
			map.getSource(MapDataSource.AIRCRAFT_ALERTS).setData(GeoHelper.emptyGeoJson(aircraftToDisplay));
		}
	}
};
export default AviationAlertsStore;
